import { getUrlParamByName } from './get-url-param';

const SESSIONSTORAGE_FAKE_USERNAME_KEY = 'tofu-auth-fake-username';

function saveFakeUsername(fakeUsername: string) {
  try {
    sessionStorage.setItem(SESSIONSTORAGE_FAKE_USERNAME_KEY, fakeUsername);
  } catch {
    // hakuna matata
  }
}

function restoreFakeUsername() {
  try {
    return sessionStorage.getItem(SESSIONSTORAGE_FAKE_USERNAME_KEY) || null;
  } catch {
    return null;
  }
}

function getFakeUsernameFromQuerystring() {
  const fakeUsername = getUrlParamByName('user') || null;
  return fakeUsername;
}

export function getFakeUsername() {
  const username = getFakeUsernameFromQuerystring() || restoreFakeUsername();
  if (!username) return 'anonymous';

  saveFakeUsername(username);
  return username;
}
